export const REGION_SEASON_STORAGE_KEY = 'panorama-region-season';
